import React, { useState } from "react";
import { Row, Col, FormInstance, Checkbox, Button } from "antd";
import CreditCardForm from "../../Shared/CreditCardForm/CreditCardForm";
import commonStyles from "../../WandaPlusSubscription/WandaPlusSubscription.module.scss";
import checkBoxStyles from "../../DashBoard/DashBoard.module.scss";
import { useCreditCardActions } from "../../../hooks/useCreditCardActions";
import { usePaymentDetailsCtx } from "../../../context/PaymentDetailsContext";

type Props = {
  form: FormInstance;
  handleCreateTrip: Function;
};

const DifferentCard: React.FC<Props> = ({ form, handleCreateTrip }) => {
  const [shouldSaveCard, setShouldSaveCard] = useState<boolean>(true);
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    isValidCCState,
    validateAndCheckForm,
    shouldDisableButton,
    saveCreditCard,
  } = useCreditCardActions(form);

  const { getDefaultSavedCreditCard } = usePaymentDetailsCtx();

  const handleShouldSaveCard = () => setShouldSaveCard(!shouldSaveCard);

  const handleBookService = async () => {
    try {
      setIsLoading(true);
      const { paymentInstrumentId } = await saveCreditCard(shouldSaveCard);
      handleCreateTrip(paymentInstrumentId);
      shouldSaveCard && getDefaultSavedCreditCard();
    } catch (error) {
      // already showing error message on CC Form
    } finally {
      setIsLoading(false);
      setBtnDisabled(true)
    }
  };

  return (
    <>
      <Row justify="center" gutter={[0, 50]}>
        <Col span={24} className={commonStyles.upgradePlanTitle}>
          Credit Card Details
        </Col>
        <Col span={24} />
      </Row>

      <Row justify="center">
        <Col span={24}>
          <CreditCardForm
            form={form}
            isValidCCState={isValidCCState}
            validateAndCheckForm={validateAndCheckForm}
          />
        </Col>

        <Col>
          <Checkbox
            className={checkBoxStyles.cancelCheckbox}
            onChange={handleShouldSaveCard}
            checked={shouldSaveCard}
          ></Checkbox>
          <span className={checkBoxStyles.cancelCheckbox}>
            {" "}
            Save card for next time
          </span>
        </Col>

        <Col span={24} />

        <Col>
          <Button
            className={`${
              commonStyles.registrationCreditFormUpgradeBtn
            } ${shouldDisableButton && commonStyles.disableBtnOpacity}`}
            onClick={handleBookService}
            disabled={shouldDisableButton || btnDisabled}
            loading={isLoading}
          >
            Book Service 
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default DifferentCard;
